import { data } from 'data/2025';
export const availableYears = [2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025] as const;
export type AvailableYear = typeof availableYears[number];
export const defaultYear: AvailableYear = 2025;

export type YearData = typeof data;
